import { TListParams } from '~/types/global';
import {
  CREATE_MESSAGE,
  CREATE_MESSAGE_ERR,
  CREATE_MESSAGE_OK,
  DO_MESSAGES_CLEANUP,
  GET_MESSAGES,
  GET_MESSAGES_ERR,
  GET_MESSAGES_OK
} from "./actionTypes";
import { CreateMessageRequest, GetMessagesResponse } from '~/types/backend';

export const getMessages = (params: TListParams) => ({
  type: GET_MESSAGES,
  payload: { params }
});

export const getMessagesOk = (response: GetMessagesResponse) => ({
  type: GET_MESSAGES_OK,
  payload: { response }
});

export const getMessagesErr = (error: Error) => ({
  type: GET_MESSAGES_ERR,
  payload: { error }
});

export const createMessage = (data: CreateMessageRequest) => ({
  type: CREATE_MESSAGE,
  payload: { data }
});

export const createMessageOk = (response: boolean) => ({
  type: CREATE_MESSAGE_OK,
  payload: { response }
});

export const createMessageErr = (error: Error) => ({
  type: CREATE_MESSAGE_ERR,
  payload: { error }
});

export const doMessagesCleanup = () => ({
  type: DO_MESSAGES_CLEANUP,
});